import React, { memo } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';

import { AppState } from 'services/types';
import { VirtualizedTableProps } from 'services/virtualizedTable/types';
import { makeSelectVirtualizedTableItemValue } from 'services/virtualizedTable/selectors';

type OwnProps = VirtualizedTableProps;

export interface ConnectedProps {
    itemValue?: ReturnType<
        ReturnType<typeof makeSelectVirtualizedTableItemValue>
    >;
}

export type Props = OwnProps & ConnectedProps;

export const VirtualizedTableItemListValueCountComponent = (
    props: Props
): React.ReactElement | null => {
    const { itemValue } = props;

    if (Array.isArray(itemValue) && itemValue.length) {
        return <React.Fragment>{itemValue.length}</React.Fragment>;
    }

    return null;
};

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    itemValue: makeSelectVirtualizedTableItemValue()
});

export default connect(mapStateToProps)(
    memo(VirtualizedTableItemListValueCountComponent, isEqual)
);
